module.exports = __webpack_public_path__ + "media/images/img-archer-56ff74b0a9a1ec3038252397d9aa712f.svg";